import { makeApi } from "@zodios/core";
import { z } from "zod";

import { kiliDataTableSearchRequestBody } from "@/data/api/kili/common/datatable/data-table-request.type";
import { installedApplianceCategoriesSchema } from "@/data/api/kili/sites/types/installed-appliance-categories.type";
import {
  applyPlanningOverrideSchema,
  planningOverridesBySectionSchema,
} from "@/data/api/kili/sites/types/planning.type";
import { siteAnomalies } from "@/data/api/kili/sites/types/site-anomalies.type";
import { siteSectionsDataTable, siteSectionsEntitiesResponse } from "@/data/api/kili/sites/types/site-sections.type";
import { siteDetailsResponseSchema, sitesResponseSchema } from "@/data/api/kili/sites/types/sites.type";
import { EProgramApplianceCategory } from "@/domains/v4b/program/program.types";

export const sitesApi = makeApi([
  {
    method: "get",
    path: "/:siteId/anomalies",
    response: siteAnomalies,
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
    alias: "getSiteAnomalies",
  },
  {
    method: "get",
    path: "/:siteId/appliance-categories/:applianceCategory/planning-overrides-by-section",
    response: planningOverridesBySectionSchema,
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
      {
        type: "Path",
        name: "applianceCategory",
        schema: z.nativeEnum(EProgramApplianceCategory),
      },
    ],
    alias: "getPlanningOverridesBySection",
  },
  {
    method: "patch",
    path: "/:siteId/appliance-categories/:applianceCategory/planning-overrides-by-section",
    response: z.unknown(), // 200 OK
    alias: "applyPlanningOverridesBySection",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
      {
        type: "Path",
        name: "applianceCategory",
        schema: z.nativeEnum(EProgramApplianceCategory),
      },
      {
        type: "Body",
        name: "body",
        schema: applyPlanningOverrideSchema,
      },
    ],
  },
  {
    method: "get",
    path: "/:siteId/appliance-categories",
    response: installedApplianceCategoriesSchema,
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
    alias: "getSiteInstalledApplianceCategories",
  },
  {
    method: "get",
    path: "/",
    response: sitesResponseSchema,
    alias: "getSites",
  },
  {
    method: "post",
    path: "/:siteId/sections/search",
    response: siteSectionsEntitiesResponse,
    alias: "searchSiteSections",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: kiliDataTableSearchRequestBody(siteSectionsDataTable).required(),
      },
      {
        name: "siteId",
        type: "Path",
        schema: z.number(),
      },
    ],
  },
  {
    method: "get",
    path: "/:siteId",
    response: siteDetailsResponseSchema,
    alias: "getSiteDetails",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
  },
]);
